import { Route, Routes } from 'react-router-dom';
import BalanceSheet from '../pages/sys/Accounting/BalanceSheet';
import IncomeStatement from '../pages/sys/Accounting/IncomeStatement';
import Report from '../pages/sys/Report';
import ReportForm from '../pages/sys/ReportForm';
import MultiEntryForm from '../pages/sys/MultiEntryForm';
import MultiEntryForm2 from '../pages/sys/MultiEntryForm2';
import MultiEntryForm3 from '../pages/sys/MultiEntryForm3';
import MultiEntryJson from '../pages/sys/MultiEntryJson';
import SalesPurchase from '../pages/sys/SalesPurchase';
import SalesPurchaseNoPaid from '../pages/sys/SalesPurchaseNoPaid';
import CSVUploader from '../pages/sys/CSVUploader';
import SqlHome from '../pages/sql/Home';
import SqlViewer from '../pages/sys/SqlViewer';
import MultiEntryForm4 from '../pages/sys/MultiEntryForm4';
import SalesPurchaseJson from '../pages/sys/SalesPurchaseJson';
import PhpMyAdmin from '../pages/sql/PhpMyAdmin';
export const ReportRoutes = [
  <Route
    key="balance-sheet"
    path="/report/balance-sheet"
    element={<BalanceSheet />}
  />,
  <Route
    key="income-statement"
    path="/report/income-statement"
    element={<IncomeStatement />}
  />,
  <Route key="report-route" path="/report/:route" element={<Report />} />,
  <Route key="app-list" path="/app-list/:route" element={<Report />} />,
  <Route
    key="form-report"
    path="/form-report/:route"
    element={<ReportForm />}
  />,
  <Route
    key="activity-report"
    path="/activity-report/:route"
    element={<ReportForm />}
  />,
  <Route key="map-report" path="/map-report/:route" element={<ReportForm />} />,
  <Route
    key="multi-entry"
    path="/multi-entry/:route"
    element={<MultiEntryForm />}
  />,
  <Route
    key="multi-entry2"
    path="/multi-entry2/:route"
    element={<MultiEntryForm2 />}
  />,
  <Route
    key="multi-entry3"
    path="/multi-entry3/:route"
    element={<MultiEntryForm3 />}
  />,
  <Route
    key="multi-entry4"
    path="/multi-entry4/:route"
    element={<MultiEntryForm4 />}
  />,
  <Route
    key="multi-entry-json"
    path="/multi-entry-json/:route"
    element={<MultiEntryJson />}
  />,
  <Route
    key="sales-purchase"
    path="/sales-purchase/:route"
    element={<SalesPurchase />}
  />,
  <Route
    key="sales-purchase-nopaid"
    path="/sales-purchase-nopaid/:route"
    element={<SalesPurchaseNoPaid />}
  />,
  <Route
    key="csv-uploader"
    path="/csv-uploader/:route"
    element={<CSVUploader />}
  />,
  <Route key="report-ktc-sql" path="/report/ktc-sql" element={<SqlHome />} />,
  <Route
    key="report-sql-updates"
    path="/report/sql-updates"
    element={<SqlViewer />}
  />,
  <Route
    key="sales-purchase-json"
    path="/sales-purchase-json/:route"
    element={<SalesPurchaseJson />}
  />,
  <Route key="php-my-admin" path="/php-my-admin" element={<PhpMyAdmin />} />,
];
